<template>
  <form v-if="team">
    <div
      class="modal-card"
      style="width: auto">
      <header class="modal-card-head">
        <p
          class="modal-card-title">
          <translate>Ändra Lag Namn</translate>
        </p>
      </header>
      <section class="modal-card-body">
        <b-field
          :label="$gettext('Nummer')">
          <b-input
            v-model="team.number"
            type="number"
            :placeholder="$gettext('Lagets Nummer')"
            required />
        </b-field>
        <b-field
          :label="$gettext('Namn')">
          <b-input
            v-model="team.name"
            type="string"
            :placeholder="$gettext('Tävlingens namn')"
            required />
        </b-field>
        <b-field
          v-if="countries"
          :label="$gettext('Land')">
          <b-select
            v-model="team.country"
            :placeholder="$gettext('Select a name')">
            <option
              v-for="thiscountry in countries"
              :key="thiscountry.pk"
              :value="thiscountry.pk">
              {{ thiscountry.name }}
            </option>
          </b-select>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button
          class="button is-primary"
          @click="save">
          <translate>Spara</translate>
        </button>
      </footer>
    </div>
  </form>
</template>


<script>
import { teamService, countryService } from '../../_services';

export default {
  name: 'EditTeam',
  props: {id: {type: Number, default: null}},
  data() {
    return {
      countries: undefined,
      team: undefined,
    }
  },
  async created() {
    var self = this
    try{
      self.team = await teamService.get(self.id)
    }catch(err){
      console.error('Caught error')
      console.error(err)
    }
    self.countries = await countryService.getAll(self.id)
  },
  methods: {
    save: async function(){
      await teamService.put(this.id, this.team)
    }
  },
}
</script>
